import { trpc } from '@/shared/api/trpc';

export const useSetFlag = () => {
  const utils = trpc.useUtils();
  return trpc.tasks.setFlag.useMutation({
    onSettled: (row) => {
      utils.tasks.list.invalidate();
      utils.tasks.flaggedCount.invalidate();
      utils.tasks.getNextActions.invalidate();
      if (row?.id) utils.tasks.byId.invalidate({ id: row.id });
    },
  });
};
